import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AdministracionLineasCreditoComponent } from './Components/administracion-lineas-credito/administracion-lineas-credito.component';
import { AdministracionMontosIntermediarioComponent } from './Components/administracion-montos-intermediario/administracion-montos-intermediario.component';
import { AdministracionGarantiaIntermediarioComponent } from './Components/administracion-garantia-intermediario/administracion-garantia-intermediario.component';
import { CrearLineasCreditoComponent } from './Components/crear-lineas-credito/crear-lineas-credito.component';
import { CrearUsuarioIFComponent } from './Components/CrearUsuarioIF/crear-usuario-if/crear-usuario-if.component';
import { HomeIntermediarioFinancieroComponent } from './Components/home-intermediario-financiero/home-intermediario-financiero.component';
import { IntermediarioHeaderComponent } from './Components/intermediario-header/intermediario-header.component';
import { LoginIFComponent } from './Components/LoginIF/login-if/login-if.component';
import { ParametrizacionActividadesEconomicasComponent } from './Components/parametrizacion-actividades-economicas/parametrizacion-actividades-economicas.component';
import { PropuestaIntermediarioComponent } from './Components/propuesta-intermediario/propuesta-intermediario.component';
import { IntermediarioRoutingModule } from './intermediario-routing.module';
import { RevisarSolicitudesIfComponent } from './Components/revisar-solicitudes-if/revisar-solicitudes-if.component';
import { AprobarSolicitudesIfComponent } from './Components/aprobar-solicitudes-if/aprobar-solicitudes-if.component';
import { AprobarOfertaIfComponent } from './Components/aprobar-oferta-if/aprobar-oferta-if.component';
import { NegarOfertaIfComponent } from './Components/negar-oferta-if/negar-oferta-if.component';
import { DevolverOfertaIfComponent } from './Components/devolver-oferta-if/devolver-oferta-if.component';
import { ConfirmarNegacionIfComponent } from './Components/confirmar-negacion-if/confirmar-negacion-if.component';
import { DevolverNegacionIfComponent } from './Components/devolver-negacion-if/devolver-negacion-if.component';
import { VerDetallePropuestaComponent } from './Components/ver-detalle-propuesta/ver-detalle-propuesta.component';
import { AdministracionUbicacionesComponent } from './Components/administracion-ubicaciones/administracion-ubicaciones.component';
import { CrearUbicacionesIntermediarioComponent } from './Components/crear-ubicaciones-intermediario/crear-ubicaciones-intermediario.component';
import { EditarUbicacionesIntermediarioComponent } from './Components/editar-ubicaciones-intermediario/editar-ubicaciones-intermediario.component';
import { LayoutComponent } from './Components/layout/layout.component';
import { ModificarUsuarioIfPrincipalComponent } from './Components/modificar-usuario-if-principal/modificar-usuario-if-principal.component';
import { AdministracionFechaYHoraComponent } from './Components/administrar-fechas-y-rangos/administracion-fecha-y-hora/administracion-fecha-y-hora.component';
import { EditarUsuarioIfComponent } from './Components/editar-usuario-if/editar-usuario-if.component';
import { CrearParametrizacionComponent } from './Components/administrar-fechas-y-rangos/crear-parametrizacion/crear-parametrizacion.component';
import { ConfirmarDesembolsoSolicitudMicroempresarioComponent } from './Components/confirmar-desembolso-solicitud-microempresario/confirmar-desembolso-solicitud-microempresario.component';
import { DesbloquearUsuariosComponent } from './Components/desbloquear-usuarios/desbloquear-usuarios.component';
import { ConsultaPerfilesIfComponent } from './Components/consulta-perfiles-if/consulta-perfiles-if.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConsultaRolesNoutilizadosifComponent } from './Components/consulta-roles-noutilizadosif/consulta-roles-noutilizadosif.component';
import { NeoComunService } from '../comun/services/neoComun.service';
import { ConsultarHistoricoUsuariosIFComponent } from './Components/consultar-historico-usuarios-if/consultar-historico-usuarios-if.component';
import { CambiarContrasenaComponent } from './Components/cambiar-contrasena/cambiar-contrasena.component';
import { ConsultaSolicitudesIfComponent } from './Components/consulta-solicitudes-if/consulta-solicitudes-if.component';
import { ConsultaDesembolsoIfComponent } from './Components/consulta-desembolso-if/consulta-desembolso-if.component';

import { ConsultarLogsAuditoriaComponent } from './Components/consultar-logs-auditoria/consultar-logs-auditoria.component';
import { NeoIntermediarioFinancieroService } from './Service/neoIntermediarioFinanciero.service';
import {ConsultarMicroempresariosComponent} from './Components/consultar-microempresarios/consultar-microempresarios.component';
import {ConsultarHistoricoSolicitudesComponent} from './Components/consultar-historico-solicitudes/consultar-historico-solicitudes.component';
import { ConsultarCuentasDeCobroComponent } from './Components/consultar-cuentas-de-cobro/consultar-cuentas-de-cobro.component';
import { VerDetalleComisionComponent } from './Components/ver-detalle-comision/ver-detalle-comision.component';
import { AdministracionParametrizacionAliadoComponent } from './Components/administracion-parametrizacion-aliado/administracion-parametrizacion-aliado.component';
import { AdministrarNivelVentasComponent } from './Components/administrar-nivel-ventas/administrar-nivel-ventas.component';
import { AdministrarCentralesRiesgoComponent } from './Components/administrar-centrales-riesgo/administrar-centrales-riesgo.component';
import { AdministrarBurosCreditoComponent } from './Components/administrar-buros-credito/administrar-buros-credito.component';

import { NeoOperadorDatosService } from '../comun/services/neoOperadorDatos.service';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import { CoreModule } from '../core/core.module';


@NgModule({
  declarations: [
    LoginIFComponent,
    CrearUsuarioIFComponent,
    AdministracionMontosIntermediarioComponent,
    AdministracionGarantiaIntermediarioComponent,
    ParametrizacionActividadesEconomicasComponent,
    IntermediarioHeaderComponent,
    HomeIntermediarioFinancieroComponent,
    AdministracionLineasCreditoComponent,
    CrearLineasCreditoComponent,
    PropuestaIntermediarioComponent,
    RevisarSolicitudesIfComponent,
    AprobarSolicitudesIfComponent,
    AprobarOfertaIfComponent,
    NegarOfertaIfComponent,
    DevolverOfertaIfComponent,
    ConfirmarNegacionIfComponent,
    DevolverNegacionIfComponent,
    VerDetallePropuestaComponent,
    AdministracionUbicacionesComponent,
    CrearUbicacionesIntermediarioComponent,
    EditarUbicacionesIntermediarioComponent,
    AdministracionParametrizacionAliadoComponent,
    //Layout
    LayoutComponent,
    ModificarUsuarioIfPrincipalComponent,
    EditarUsuarioIfComponent,
    AdministracionFechaYHoraComponent,
    CrearParametrizacionComponent,
    ConfirmarDesembolsoSolicitudMicroempresarioComponent,
    DesbloquearUsuariosComponent,
    ConsultaPerfilesIfComponent,
    ConsultaRolesNoutilizadosifComponent,
    ConsultarHistoricoUsuariosIFComponent,
    CambiarContrasenaComponent,
    ConsultaSolicitudesIfComponent,
    ConsultaDesembolsoIfComponent,
    ConsultarLogsAuditoriaComponent,
    ConsultarMicroempresariosComponent,
    ConsultarHistoricoSolicitudesComponent,
    ConsultarCuentasDeCobroComponent,
    VerDetalleComisionComponent,
    AdministrarNivelVentasComponent,
    AdministrarCentralesRiesgoComponent,
    AdministrarBurosCreditoComponent
  ],
  imports: [
    SharedModule,
    CoreModule,
    IntermediarioRoutingModule,
    NgxPaginationModule,
    NgbTooltipModule
  ],
  providers: [CurrencyPipe, NeoComunService, NeoIntermediarioFinancieroService, NeoOperadorDatosService],
})
export class IntermediarioModule {}
